import { createContext } from "react";

export const VerifiedPhoneContext = createContext(null);

export function verifiedPhoneFromLogin(data, requestedOwner, currentOwner, requestedType, currentType) {
  if (!data || typeof data !== "object" || Array.isArray(data) || data.status === false || data.error) return null;
  const owner = String(requestedOwner || "");
  if (!/^[1-9]\d*$/.test(owner) || owner !== String(currentOwner || "") || owner !== String(data.user_id || "")) return null;
  if (!requestedType || requestedType !== currentType || requestedType !== data.user_type) return null;
  if (typeof data.user_phonenumber !== "string") return null;
  const phone = data.user_phonenumber.replace(/[\s().-]/g, "");
  return /^\+?\d{9,15}$/.test(phone) && !phone.startsWith("+0") ? phone : null;
}
